import React from 'react';

import { Button, Center, Modal, ModalProps, PasswordInput, Space } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { GuestSmartAssistantService } from 'services/guest-smart-assistant-service';

interface GuestSmartAssistantPasswordGuardModalProps extends ModalProps {
  onAuthentificationSuccess: () => void;
  smartAssistantId: string;
}

export function GuestSmartAssistantPasswordGuardModal({
  onAuthentificationSuccess,
  smartAssistantId,
  ...modalProps
}: GuestSmartAssistantPasswordGuardModalProps) {
  const { t } = useTranslation();

  const passwordForm = useForm({
    initialValues: { text: '' }
  });

  const validatePasswordMutation = useMutation({
    mutationFn: GuestSmartAssistantService.validatePassword,
    onSuccess: () => {
      onAuthentificationSuccess();
    },
    onError: () => passwordForm.setFieldError('text', t('SMART_ASSISTANT.REQUIRE_PASSWORD.ERROR'))
  });

  const onPasswordSubmit = () => {
    const validation = passwordForm.validate();
    if (validation.hasErrors) return;
    validatePasswordMutation.mutate({ smartAssistantId, password: passwordForm.values.text });
  };

  return (
    <Modal {...modalProps} withCloseButton={false} title={t('SMART_ASSISTANT.REQUIRE_PASSWORD.TITLE')} size={350}>
      <form onSubmit={passwordForm.onSubmit(() => onPasswordSubmit())}>
        <PasswordInput
          placeholder={t('SMART_ASSISTANT.REQUIRE_PASSWORD.PLACEHOLDER')}
          {...passwordForm.getInputProps('text')}
        />
        <Space h={20} />
        <Center>
          <Button
            loading={validatePasswordMutation.isLoading}
            disabled={!passwordForm.values.text.trim()}
            onClick={() => onPasswordSubmit()}>
            {t('APP.ACTIONS.SUBMIT')}
          </Button>
        </Center>
      </form>
    </Modal>
  );
}
